<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
    slug: String
})

const TopicSvg = defineAsyncComponent(() => import(`../../../../svg/topic-${props.slug}.svg?component`))
</script>

<template>
    <TopicSvg />
</template>
